import { CampaignCode, SubscriptionType } from "../../../models";

export const offeringCodesToDoubleData: Partial<Record<SubscriptionType, string>> = {
    TELIA_MOBIL_02GB: "6 GB",
    TELIA_MOBIL_06GB: "16 GB",
    TELIA_MOBIL_10GB: "30 GB",
    TELIA_MOBIL_15GB: "40 GB",
    // New
    TELIA_MOBIL_03GB: "6 GB",
    TELIA_MOBIL_03GB_2027: "6 GB",
    TELIA_MOBIL_15GB_2027: "30 GB",
    TELIA_MOBIL_05GB: "10 GB",
    TELIA_MOBIL_05GB_2025: "10 GB",
    TELIA_MOBIL_05GB_2026: "10 GB",
    TELIA_MOBIL_05GB_2025_2: "10 GB",
    TELIA_MOBIL_08GB: "16 GB",
    TELIA_MOBIL_10GB_UNG: "20 GB",
    TELIA_MOBIL_10GB_UNG_2026: "20 GB",
    TELIA_MOBIL_15GB_02: "30 GB",
    TELIA_MOBIL_20GB: "40 GB",
    // Athena
    TELIA_MOBIL_10GB_02: "20 GB",
    TELIA_MOBIL_10GB_2025: "20 GB",
    TELIA_MOBIL_10GB_2026: "20 GB",
    TELIA_MOBIL_10GB_2025_2: "20 GB",
    TELIA_JUNIOR_01GB: "2 GB",
    TELIA_JUNIOR_03GB: "10 GB",
    // Summer Campaign
    "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026": "Junior 2 GB",
    "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026": "Junior 20 GB",
};

export const offeringCodesToDoubleDataAmount: Partial<Record<SubscriptionType, string>> = {
    TELIA_MOBIL_02GB: "6",
    TELIA_MOBIL_06GB: "16",
    TELIA_MOBIL_10GB: "30",
    TELIA_MOBIL_15GB: "40",
    // New
    TELIA_MOBIL_03GB: "6",
    TELIA_MOBIL_03GB_2027: "6",
    TELIA_MOBIL_15GB_2027: "30",
    TELIA_MOBIL_05GB: "10",
    TELIA_MOBIL_05GB_2025: "10",
    TELIA_MOBIL_05GB_2026: "10",
    TELIA_MOBIL_08GB: "16",
    TELIA_MOBIL_15GB_02: "30",
    TELIA_MOBIL_20GB: "40",
    TELIA_MOBIL_10GB_02: "20",
    TELIA_MOBIL_10GB_2025: "20",
    TELIA_MOBIL_10GB_2026: "20",
    TELIA_JUNIOR_01GB: "2",
    TELIA_JUNIOR_03GB: "10",
    // Summer Campaign
    "TELIA_JUNIOR_01GB+PROMO_JR06_50_2026": "2",
    "TELIA_JUNIOR_10GB_2026+PROMO_JR06_50_2026": "20",
};

export const offeringCodesToDoubleSpeed: SubscriptionType[] = [
    /*
    "TELIA_MOBIL_X_NORMAL",
    "TELIA_MOBIL_X_RASK"
    */
];

export const offeringCodesToCampaign: Partial<Record<SubscriptionType, CampaignCode>> = {
    TELIA_MOBIL_02GB: "COM12PURP10",
    TELIA_MOBIL_06GB: "COM12PURP10",
    TELIA_MOBIL_10GB: "COM12PURP10",
    TELIA_MOBIL_10GB_2025: "COM12PURP10",
    TELIA_MOBIL_10GB_2026: "COM12PURP10",
    TELIA_MOBIL_15GB: "COM12PURP10",
    TELIA_MOBIL_03GB: "COM12PURP10",
    TELIA_MOBIL_05GB: "COM12PURP10",
    TELIA_MOBIL_05GB_2025: "COM12PURP10",
    TELIA_MOBIL_05GB_2026: "COM12PURP10",
    TELIA_MOBIL_08GB: "COM12PURP10",
    TELIA_MOBIL_15GB_02: "COM12PURP10",
    TELIA_MOBIL_20GB: "COM12PURP10",
    TELIA_MOBIL_X_RASK_VT: "COM12KR3",
    TELIA_MOBIL_X_RASK_VT_2026: "COM12KR3",
    TELIA_MOBIL_03GB_2027: "COM12PURP10",
    TELIA_MOBIL_15GB_2027: "COM12PURP10",
};

export const offeringCodesToCampaign20Percentage: Partial<Record<SubscriptionType, CampaignCode>> = {
    TELIA_X_BASIC_2025_2: "COM12PURP20",
    TELIA_X_BASIC_2026: "COM12PURP20",
    TELIA_X_BASIC_2027: "COM12PURP20",
    TELIA_X_MAX_2025: "COM12PURP20",
    TELIA_X_MAX_2026: "COM12PURP20",
    TELIA_X_MAX_2027: "COM12PURP20",
    TELIA_X_MAX_PLUS_2025: "COM12PURP20",
    TELIA_X_MAX_PLUS_2026: "COM12PURP20",
    TELIA_X_MAX_PLUS_2027: "COM12PURP20",
    TELIA_X_START_2025: "COM12PURP20",
    TELIA_X_START_2026: "COM12PURP20",
    TELIA_X_START_2027: "COM12PURP20",
    TELIA_MOBIL_10GB_2025: "COM12PURP20",
    TELIA_MOBIL_10GB_2026: "COM12PURP20",
    TELIA_MOBIL_10GB_2025_2: "COM12PURP20",
    TELIA_MOBIL_X_UNG_2025_2: "COM12PURP20",
    TELIA_MOBIL_X_UNG_2026: "COM12PURP20",
};
